// extracted by mini-css-extract-plugin
export default {"container":"app-shell_container__fAbmS","main":"app-shell_main__DzzlS","header":"app-shell_header__bFOs7","secondaryNavbar":"app-shell_secondaryNavbar__jESQb"};